import React, { useEffect, useState } from 'react';
import LegendSegment from './LegendSegment';

import './HeatmapLegend.scss';
import { lerp } from '../utils';

const HeatmapLegend = (props) => {
  const [legendSegments, setLegendSegments] = useState([]);
  const [segWidth, setSegWidth] = useState('10%');
  const [numSegments, setNumSegments] = useState(10);

  //Legend resizing
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return (_) => {
      window.removeEventListener('resize', handleResize);
    };
  }, [document.documentElement.clientWidth, window.innerWidth]);

  useEffect(() => {
    handleResize();
  }, [props.isPerCapita]);

  const handleResize = () => {
    const pxPerCapita = 140;
    const pxTotal = 130;
    const vw =
      Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0,
      ) * 0.66;

    let numSegments = Math.ceil(
      vw / (props.isPerCapita ? pxPerCapita : pxTotal),
    );
    if (numSegments > 10) numSegments = 10;
    setNumSegments(numSegments);
    setSegWidth(100 / numSegments + '%');
  };

  useEffect(() => {
    setLegendSegments(() => {
      return generateLegend(
        props.startColor,
        props.endColor,
        numSegments,
        props.maxNum,
      );
    });
  }, [props.startColor, props.endColor, numSegments, props.maxNum]);

  const generateLegend = (startColor, endColor, steps, maxNum) => {
    const percPerStep = 1 / steps;
    return Array(steps)
      .fill()
      .map((_, ind) => {
        const perc = (ind + 1) * percPerStep;
        const returnable = {
          color: lerp(startColor, endColor, perc),
          desc: (
            parseFloat(
              (perc * maxNum).toPrecision(props.toPrecision),
            ) + ''
          ).replace(',', '.'),
        };
        return returnable;
      });
  };

  return (
    <div className="cviz-heatmap-legend">
      {/* <span className="desc">{trans.heatmap.numberOfCases[props.lang]}</span> */}
      <span>
        <div
          className="cviz-segments"
          style={{ '--seg-width': segWidth }}
        >
          {legendSegments && (
            <>
              <div className="cviz-heatmap-legend-starter-cell">
                0
              </div>
              {legendSegments.map((segmentConfig, ind) => {
                return (
                  <LegendSegment
                    key={'cviz-legend-segment--' + ind}
                    color={segmentConfig.color}
                    desc={segmentConfig.desc}
                  />
                );
              })}
            </>
          )}
        </div>
      </span>
    </div>
  );
};

export default HeatmapLegend;
